import { type Opportunity } from "@repo/api";
import { t } from "@repo/translation";
import { isDefined } from "@repo/utils";
import { differenceInDays, isToday, isTomorrow } from "date-fns";

export const getExpiryStatus = (
  expiryDate: string | Date
): { text: string; color: "yellow" | "orange" } => {
  const d = expiryDate instanceof Date ? expiryDate : new Date(expiryDate);
  const today = new Date();
  let text: string;
  let color: "yellow" | "orange" = "yellow";

  if (isToday(d)) {
    text = t("label.expires_today");
  } else if (isTomorrow(d)) {
    text = t("label.expires_tomorrow");
  } else {
    const daysDifference = differenceInDays(d, today);
    if (daysDifference > 0) {
      text = t("label.expires_in_days", {
        days: daysDifference,
      });
    } else {
      text = t("label.expired");
      color = "orange";
    }
  }

  return { text, color };
};

export const isExpiringSoon = (expiryDate: string) => {
  const currentDate = new Date();
  const expiry = new Date(expiryDate);
  const daysDifference = differenceInDays(expiry, currentDate);

  return daysDifference <= 2;
};

export const getQuotationNumbers = (opportunity?: Opportunity) =>
  [...(opportunity?.quotations?.quotationInfo?.map((q) => q.id) ?? [])].filter(
    isDefined
  );

export const isValidQuotation = (quotationId?: string) => {
  if (!quotationId) {
    return false;
  }
  const regex = /^Q\d+-\d+$/;
  return regex.test(quotationId);
};
